<div class="vehicle-status-item__vehicle-header">
  <div>
    <div class="vehicle-status-item__vehicle-header__top-row">
      <h4 [fmTooltip]="vehicle.vehicleName" [showTooltipIfOverflow]="true" class="vehicle-status-item__vehicle-header__top-row__name">
        {{ vehicle.vehicleName }}
      </h4>
      <mat-icon
        *ngIf="showEVTag"
        fmTooltip="Electric Vehicle"
        i18n-fmTooltip="@@S_ELECTRIC_VEHICLE_TOOLTIP"
        svgIcon="ic-electric-vehicle-badge"
        class="vehicle-status-item__vehicle-header__top-row__electric-vehicle-icon mat-icon-size-xs"
      ></mat-icon>
      <mat-icon
        *ngIf="vehicleStatusInfo?.showHealthStatus && checkVehicleHealthIssue()"
        svgIcon="ic-health-status-critical"
        fmTooltip
        [fmTooltipTemplate]="vehicleDeviceHealthStatusToolTip"
        class="vehicle-status-item__vehicle-header__top-row__health-status-icon"
        a7s-id="live-map-vehicle-issue-badge-icon-hover"
      >
      </mat-icon>
    </div>
    <p *ngIf="trimmedDriverName !== ',' && trimmedDriverName !== ''" class="vehicle-status-item__vehicle-header-driver-name">
      {{ trimmedDriverName }}
    </p>
  </div>
  <div class="vehicle-status-item__vehicle-header-menu">
    <mat-icon
      #normalSignalIcon
      class="vehicle-status-item__vehicle-header-menu-icon vehicle-status-item__vehicle-header-menu-signal mat-icon-size-xs"
      *ngIf="vehicleStatusInfo?.showGPSSignalStrength && vehicle.signalStatus.iconClass === ESignalStatus.Normal"
      [svgIcon]="'ic-signal-' + vehicle.signalStatus.iconClass"
      i18n-fmTooltip="@@S_MAP_SIDE_BAR_GPS_NORMAL_SIGNAL"
      fmTooltip="GPS network coverage in this area is normal"
    >
    </mat-icon>
    <mat-icon
      #lowSignalIcon
      class="vehicle-status-item__vehicle-header-menu-icon vehicle-status-item__vehicle-header-menu-signal mat-icon-size-xs"
      *ngIf="vehicleStatusInfo?.showGPSSignalStrength && vehicle.signalStatus.iconClass === ESignalStatus.Low"
      [svgIcon]="'ic-signal-' + vehicle.signalStatus.iconClass"
      i18n-fmTooltip="@@S_MAP_SIDE_BAR_GPS_WEAK_SIGNAL"
      fmTooltip="GPS network coverage in this area is low - vehicle position may not be accurate"
    ></mat-icon>
    <mat-icon
      #lostSignalIcon
      class="vehicle-status-item__vehicle-header-menu-icon vehicle-status-item__vehicle-header-menu-signal mat-icon-size-xs"
      *ngIf="vehicleStatusInfo?.showGPSSignalStrength && vehicle.signalStatus.iconClass === ESignalStatus.Lost"
      [svgIcon]="'ic-signal-' + vehicle.signalStatus.iconClass"
      i18n-fmTooltip="@@S_MAP_SIDE_BAR_GPS_LOST_SIGNAL"
      fmTooltip="There is no GPS network coverage in this area - map will display the last known vehicle position"
    ></mat-icon>
    <mat-icon
      a7s-id="vehicle-panel-header-vehicle-context-menu"
      class="vehicle-status-item__vehicle-header-menu-icon vehicle-status-item__vehicle-header-menu-context mat-icon-size-xs"
      svgIcon="ds-ic-elipsis"
      (click)="openVehicleContextMenuClick($event)"
    ></mat-icon>
  </div>
</div>
<div class="vehicle-status-item-body-container">
  <mat-icon [svgIcon]="'ic-' + vehicle.iconClass" class="vehicle-status-item__body__status-icon mat-icon-size-special"></mat-icon>
  <div class="vehicle-status-item__vehicle-body">
    <p *ngIf="isStoppedOrIdle && !vehicle.lastUpdateIsToday" class="vehicle-status-item__vehicle-body-status" i18n="@@S_STOPPED">Stopped</p>
    <p *ngIf="isEVChangesEnabled && isCharging && !formattedDuration" class="vehicle-status-item__vehicle-body-status" i18n="@@S_CHARGING">
      Charging
    </p>
    <p *ngIf="!isStoppedOrIdle && !isCharging && vehicleStatusInfo?.showVehicleSpeed" class="vehicle-status-item__vehicle-body-speed">
      {{ vehicle.speed | speedUnits: vehicleStatusInfo.speedUnits }}
    </p>
    <p
      *ngIf="(isStoppedOrIdle && vehicle.lastUpdateIsToday) || (isEVChangesEnabled && isCharging && formattedDuration)"
      class="vehicle-status-item__vehicle-body-duration"
    >
      {{ formattedDuration }}
    </p>
    <div class="vehicle-status-item__vehicle-body-last-update">
      <p class="vehicle-status-item__vehicle-body-last-update-text" *ngIf="vehicle.eventCode === eventCodeShutDown; else lastUpdate">
        <span i18n="@@S_LAST_MOVEMENT">Last Movement:</span> {{ vehicle.lastUpdateForDisplay }}
      </p>
      <ng-template #lastUpdate>
        <p class="vehicle-status-item__vehicle-body-last-update-text">
          <span i18n="@@S_LAST_UPDATE">Last Update:</span> {{ vehicle.lastUpdateForDisplay }}
        </p>
      </ng-template>
      <a
        *ngIf="vehicle.onsensors.length > 0"
        class="vehicle-status-item__vehicle-body-sensors"
        [fmTooltip]="[vehicle.onsensors, vehicle.offsensors] | tooltipMessageCleaner"
        i18n="@@S_SENSORS_ON"
      >
        on
      </a>
    </div>
    <p class="vehicle-status-item__vehicle-body-geofence" *ngIf="vehicle.geofenceName && vehicle.geofenceName !== ''">
      {{ vehicle.geofenceName }}
    </p>
    <p *ngIf="vehicle.address" class="vehicle-status-item__vehicle-body-address">{{ vehicle.address }}</p>
    <p
      *ngIf="vehicle.isSearchingAddress"
      class="vehicle-status-item__vehicle-body-address"
      i18n="@@S_VEHICLESTATUS_BALLOON_LOCATING_ADDRESS"
    >
      Finding address...
    </p>
    <p
      *ngIf="!vehicle.isSearchingAddress && !vehicle.address"
      class="vehicle-status-item__vehicle-body-address"
      i18n="@@S_VEHICLESTATUS_BALLOON_ADDRESS_NOT_LOCATED"
    >
      Address not found
    </p>
    <p *ngIf="vehicle.group" class="vehicle-status-item__vehicle-body-group">{{ vehicle.group }}</p>
  </div>
  <div>
    <fm-ev-battery-section
      *ngIf="isEVChangesEnabled && vehicle?.evBatteryData"
      [isCharging]="vehicle.status === EVehicleStatusType.Charging"
      [percentage]="vehicle.evBatteryData?.batteryPercentage"
      [userSettings]="userSettings"
      [vehicleStatus]="vehicle.status"
      [batteryUpdateTime]="vehicle.evBatteryData?.batteryLastUpdateTime"
    >
    </fm-ev-battery-section>
    <fm-speed-violation
      *ngIf="vehicleStatusInfo?.showSpeedLimits && vehicle.vehicleSpeedlimit > 0 && !isStoppedOrIdle"
      [speed]="vehicle.speedViolation.violationSpeed"
      [speedLimitType]="vehicleStatusInfo?.speedLimit"
      [speedType]="vehicle.vehicleSpeedlimitType"
      [country]="vehicleStatusInfo?.userCountry"
    ></fm-speed-violation>
  </div>
</div>
<ng-template #vehicleDeviceHealthStatusToolTip>
  <div class="health-status-tooltip-container">
    <fm-health-status-tooltip
      [deviceHealthStatus]="this.vehicleHealthStatus?.healthStatus ?? ''"
      [deviceType]="vehicle.type"
    ></fm-health-status-tooltip>
  </div>
</ng-template>
